import { Section } from '../UI/IgmtInk'
import HeroImage from '../../assets/ali.png'
import { useContext, useRef } from 'react'
import { ScrollContext } from '../../utils/scroll-observer'

const Home = props => {
  const refContainer = useRef(null)
  const refContainerDesk = useRef(null)
  const { scrollY } = useContext(ScrollContext)

  let progress = 0
  let progressDesk = 0

  const { current: elContainer } = refContainer
  if (elContainer) {
    progress = Math.min(1, scrollY / elContainer.clientHeight)
  }

  const { current: elContainerDesk } = refContainerDesk
  if (elContainerDesk) {
    progressDesk = Math.min(1, scrollY / elContainerDesk.clientHeight)
  }

  return (
    <>
      <Section className="flex flex-col items-center justify-center min-h-screen p-4 animate-slide-down lg:hidden sticky top-0 -z-10">
        <div className="flex-1 flex justify-center items-center">
          <div
            ref={refContainer}
            className="grid grid-cols-1 justify-items-center gap-6"
            style={{ transform: `translateY(-${progress * 20}vh)` }}
          >
            <div className="grid grid-cols-1 justify-items-center items-center gap-2">
              <p>You are invited to celebrate the</p>
              <p className='font-["Lora"] font-bold text-blue-500 text-lg'>
                CHRISTENING & 1ST BIRTHDAY
              </p>
              <p>of our Son</p>
            </div>
            <img className="w-64" src={HeroImage} alt="Ali Image" />
            <div className="grid grid-cols-1 gap-2 justify-items-center">
              <p className='font-["Courgette"] text-3xl'>Aiori Lovemir Iveen</p>
              <p className="font-bold">A. TABALNO</p>
            </div>
          </div>
        </div>

        <div className="flex-grow-0 pb-16">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6 animate-bounce"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>
      </Section>
      <Section className="hidden lg:flex flex-col justify-center items-center min-h-screen p-4 animate-slide-down sticky top-0 -z-10">
        <div className="flex-1 flex justify-center items-center">
          <div
            ref={refContainerDesk}
            className="grid grid-cols-2 justify-items-center w-full"
            style={{ transform: `translateY(-${progressDesk * 20}vh)` }}
          >
            <div className="grid grid-cols-1 gap-8">
              <div className="grid grid-cols-1 justify-items-center self-end gap-2">
                <p className="text-lg xl:text-xl">
                  You are invited to celebrate the
                </p>
                <p className='font-["Lora"] font-bold text-blue-500 text-2xl xl:text-3xl'>
                  CHRISTENING & 1ST BIRTHDAY
                </p>
                <p className="text-lg xl:text-xl">of our Son</p>
              </div>
              <div className="grid grid-cols-1 justify-items-center self-start gap-2">
                <p className='font-["Courgette"] text-4xl xl:text-6xl'>
                  Aiori Lovemir Iveen
                </p>
                <p className="font-bold text-xl xl:text-2xl">A. TABALNO</p>
              </div>
            </div>

            <img className="w-3/4" src={HeroImage} alt="Ali Image" />
          </div>
        </div>

        <div className="flex-grow-0 pb-16">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6 animate-bounce"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>
      </Section>
    </>
  )
}

export default Home
